export enum LogoFiletype {
  jpeg = 'jpeg',
  jpg = 'jpg',
  png = 'png',
  svg = 'svg',
  webp = 'webp',
  unknown = 'unknown',
}
